// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiFilter } from "@mdi/js";
import { Button, Popover, Tooltip } from "antd";

import { RigFracLayerFilter } from "components/project/layers/components/layer-managers/shared/rig-frac-filter/RigFracLayerFilter";

interface IRigFracFilterButtonProps {
  // Layer NAME (e.g. "Rigs" / "Frac Crews") — the key the map store uses for
  // this layer's filter selections and derived options.
  layerName: string;
}

/**
 * Inline filter affordance for a rig/frac layer row, sitting beside the
 * "View Layer Details" button. Opens the layer-local attribute filter (operator,
 * basin, sub-basin, county, location type) in a popover.
 *
 * Mirrors the layer settings cog (MapLayerSettings) exactly: a plain hover
 * Tooltip wrapping an UNCONTROLLED click Popover. Controlling the popover's open
 * state and suppressing the tooltip via `open={isOpen ? false : undefined}` made
 * the "Filter" tooltip re-fire on close — the false→undefined flip handed control
 * back to antd's latched hover state. Uncontrolled, antd drives show/hide from
 * real pointer events only, so it never pops on its own.
 */
export function RigFracFilterButton({
  layerName
}: IRigFracFilterButtonProps): JSX.Element {
  return (
    <Tooltip title="Filter">
      <Popover
        content={
          <div data-testid="rig-frac-filter-menu" style={{ width: 320 }}>
            <RigFracLayerFilter layerId={layerName} />
          </div>
        }
        placement="bottomLeft"
        trigger="click"
        arrowPointAtCenter={true}>
        <Button
          type="text"
          aria-label="Filter"
          data-testid="rig-frac-filter-button"
          onClick={(evt) => {
            // Keep the row's own click handler from firing (layer select/expand);
            // antd's popover-toggle onClick still runs on the same element.
            evt.stopPropagation();
            evt.preventDefault();
          }}>
          <Icon path={mdiFilter} size={"18px"} />
        </Button>
      </Popover>
    </Tooltip>
  );
}
